<template>
    <v-card>
        <v-card-title class="text-h5">Score Flash</v-card-title>

        <v-card-text>
            <v-row align="center" class="mx-0 mt-2">
                <v-col class="mb-0 py-0">
                    Events
                    <div class="d-flex flex-row">
                        <v-checkbox v-model="selectedEvents.TI" label="Trampoline" class="mr-2" />
                        <v-checkbox v-model="selectedEvents.DM" label="Double Mini" class="mx-2" />
                        <v-checkbox v-model="selectedEvents.TU" label="Tumbling" class="mx-2" />
                        <v-checkbox v-model="selectedEvents.TS" label="Synchro" class="mx-2" />
                    </div>
                </v-col>
            </v-row>

            <v-row align="center" class="mx-0 mt-2">
                <v-col class="py-0">
                    <v-radio-group v-model="contrast" label="Contrast (leave blank for colorful)">
                        <v-radio label="Dark (Black background)" value="dark" />
                        <v-radio label="Light (White background)" value="light" />
                    </v-radio-group>
                </v-col>
            </v-row>

            <v-row align="center" class="mx-0 mt-2 mb-2">
                <v-col class="py-0" cols="4">
                    <v-select
                        v-model="equipment"
                        label="Equipment"
                        :items="[
                            { text: 'All', value: null },
                            { text: 'A', value: 'A' },
                            { text: 'B', value: 'B' },
                            { text: 'C', value: 'C' },
                        ]"
                        item-text="text"
                        item-value="value"
                    />
                </v-col>
            </v-row>

            <v-row align="center" class="mx-0 mt-2 mb-2">
                <v-col class="py-0">
                    <v-checkbox v-model="viewOnly" label="View only (Don't mark flashed)" />
                </v-col>

                <v-col class="py-0">
                    <v-text-field
                        v-model="batchMarkAsFlashedNum"
                        :disabled="viewOnly"
                        type="number"
                        min="1"
                        label="Batch marking scores as flashed"
                        hint="This will reduce the amount of network requests made to the server as the meet is running."
                    />
                </v-col>
            </v-row>

            <v-row align="center" class="mx-0 mt-2">
                <v-col class="py-0">
                    Interval (seconds)
                    <v-slider
                        v-model="interval"
                        class="align-center"
                        step="5"
                        :max="60"
                        :min="10"
                        hide-details
                        prepend-icon="mdi-clock"
                    >
                        <template #append>
                            <v-text-field v-model="interval" class="mt-0 pt-0" type="number" style="width: 60px" />
                        </template>
                    </v-slider>
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="present"> Present </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import Meet from '@/Models/Meet.js';
import backgroundColors from '@/background-colors.js';

export default {
    name: 'MeetScoreFlashModal',

    props: {
        meet: {
            type: Meet,
            required: true,
        },
    },

    data: () => ({
        selectedSession: null,
        loadingSessions: false,
        error: null,
        selectedEvents: {
            TI: true,
            DM: true,
            TU: true,
            TS: true,
        },
        interval: 20,
        contrast: null,
        equipment: null,
        viewOnly: false,
        batchMarkAsFlashedNum: 1,
    }),

    methods: {
        present() {
            const backgroundType = this.contrast === null ? 'gradient' : 'color';

            const dark = this.contrast !== 'light' ? 'true' : 'false';

            let url = `/meets/${this.meet.id}/score-flash/live?dark=${dark}&background_type=${backgroundType}`;

            url += `&interval=${this.interval}`;

            if (this.viewOnly) {
                url += '&should_mark_flashed=false';
            }

            if (this.batchMarkAsFlashedNum) {
                url += `&batch_mark_as_flashed_num=${this.batchMarkAsFlashedNum}`;
            }

            const events = [];

            Object.keys(this.selectedEvents).forEach(eventKey => {
                if (this.selectedEvents[eventKey]) {
                    events.push(eventKey);
                }
            });

            if (events.length === 0) {
                return;
            }

            url += `&events=${events.join(',')}`;

            if (this.equipment) {
                url += `&equipment=${this.equipment}`;
            }

            if (this.contrast === 'dark') {
                url += `&background_colors[]=${encodeURIComponent('#000000,#000000')}`;
                url += '&color=ffffff';
            } else if (this.contrast === 'light') {
                url += `&background_colors[]=${encodeURIComponent('#ffffff,#ffffff')}`;
                url += '&color=000000';
            } else {
                backgroundColors.forEach(([startColor, endColor]) => {
                    url += `&background_colors[]=${encodeURIComponent(`${startColor},${endColor}`)}`;
                });
            }

            window.open(url, '_blank');
        },
    },
};
</script>
